const COMPANY_INFO = [
  { label: '会社名', value: '合同会社べごま' },
  { label: '代表者', value: '代表社員　山下将欣' },
  { label: '事業内容', value: '賃貸併用住宅建築コンサルティング事業 / 整理収納アドバイザー事業' },
  { label: '所在地', value: '東京都世田谷区' },
  { label: '設立', value: '2023年1月17日' },
];

export default function CompanySection() {
  return (
    <section id="company" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-8">
        <div className="text-center mb-16">
          <p className="text-[#1e3a70] text-sm font-medium tracking-widest uppercase mb-3">ABOUT US</p>
          <h2 className="text-3xl font-bold text-stone-800 mb-4">会社概要</h2>
          <p className="text-stone-500 text-base max-w-xl mx-auto leading-relaxed">
            住まいと暮らしをトータルにサポートする専門家集団として、お客様お一人おひとりに寄り添ったサービスを提供しています。
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div>
            <div className="divide-y divide-stone-100">
              {COMPANY_INFO.map((row) => (
                <div key={row.label} className="flex py-5 gap-6">
                  <span className="text-stone-400 text-sm font-medium w-32 flex-shrink-0">{row.label}</span>
                  <span className="text-stone-700 text-sm leading-relaxed">{row.value}</span>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
